import actions from '@/core/store/pedido/documentos/documento/editor-texto/actions'

export default { actions }
